// Auto-generated normalizer for table: CuestionarioRespuestaVerdaderoFalso
export function cuestionarioRespuestaVerdaderoFalsoNormalize(row) {
  return {
    idRespuestaVF: row.idRespuestaVerdaderoFalso ?? row.IdRespuestaVerdaderoFalso ?? row.idRespuestaVF ?? row.IdRespuestaVF ?? 0,
    idCuestionarioPreguntas: row.idRespuesta ?? row.IdRespuesta ?? row.idCuestionarioPreguntas ?? row.IdCuestionarioPreguntas ?? 0,
    respuestaCorrecta: row.respuesta ?? row.Respuesta ?? row.respuestaCorrecta ?? row.RespuestaCorrecta ?? false,
    activo: row.activo ?? row.Activo ?? true,
  };
}
